/**************************************
 * Created By LinK On 2019/11/25 16:30.
 **************************************/
export var ID = '@aliPay';
export default {
    ID: ID
};
